export const pageFaq = {
    // ロード完了したとき
    loadDone: function (results, paramList) {
        $(".js-ajax").html(results["template"]);
        $(".js-content").hide().fadeIn(300);
        $(".nursery-faq__list-container").map(function () {
            const imageId = $(this).data("faq_id");
            pageFaq.getItem(imageId);
        });

        modalWindow.enableButton();
        faq.enableButtons();

        // 保存ボタンが押されたときの挙動。
        $(".js-submit").unbind();
        $(".js-submit").click(function () {
            const url = $("#lifeForm").attr("action");
            form.post(url, "#lifeForm", "更新が完了しました", pageDetail.postDone);
        });
    },

    // 特徴の一行を取得する。
    getItem: function (itemId) {
        const paramList = new FormData();
        paramList.append("id", itemId);

        post.postAjaxData("/nursery/faq/getItem", paramList, "", pageFaq.getImageDone, null, null);
    },

    // 画像イメージが読み込まれたときの各種ボタンの定義
    getImageDone: function (results, paramList) {
        $('[data-faq_id="' + paramList.get("id") + '"]').html(results["template"]);

        modalWindow.enableButton();
        faq.enableButtons();
    }
};

// よくある質問の実装
const faq = {
    // ボタンを有効にする。
    enableButtons: function () {
        // 削除ボタンが押された。
        $(".js-btn-delete").click(function () {
            const deleteTargetId = $(this).data("id");
            $(".button-small--yes").data("deleteTargetId", deleteTargetId);
        });

        // 削除OKボタンが押されたとき
        $(".button-small--yes").click(function () {
            const paramList = new FormData();
            const deleteTargetId = $(this).data("deleteTargetId");
            paramList.append("id", deleteTargetId);

            post.postAjaxData(
                "/nursery/faq/delete",
                paramList,
                "よくある質問の項目を削除しました",
                faq.deleteDone,
                null,
                null
            );
        });

        // 特徴を追加、編集を押したとき
        $(".js-btn-edit").unbind();
        $(".js-btn-edit").click(function () {
            const paramList = new FormData();
            paramList.append("id", $(this).data("id"));

            post.postAjaxData("/nursery/faq/update", paramList, "", faq.updateLoadDone, null, null);
        });

        // 上下移動ボタンを押したとき
        $(".button-sort").unbind();
        $(".button-sort").click(function () {
            // 位置を変更
            if ($(this).hasClass("button-sort--up")) {
                const insert = $(this).parents(".nursery-faq__list-container").prev(".nursery-faq__list-container");
                if (insert) {
                    const targetObject = $(this).parents(".nursery-faq__list-container");
                    $(insert).insertAfter(targetObject);
                }
            } else {
                const insert = $(this).parents(".nursery-faq__list-container").next(".nursery-faq__list-container");
                if (insert) {
                    const targetObject = $(this).parents(".nursery-faq__list-container");
                    $(insert).insertBefore(targetObject);
                }
            }

            faq.updatePosition("移動が完了しました");
        });
    },

    updatePosition: function (message) {
        // 位置を決定する。
        let position = 1;
        const paramList = new FormData();
        $(".nursery-faq__list-container").map(function () {
            const imageId = $(this).data("faq_id");
            paramList.append("id[" + position + "]", imageId);
            position++;
        });

        post.postAjaxData("/nursery/faq/updatePosition", paramList, message, null, null, null);
    },

    // 更新ボタンをおしてロードが完了
    updateLoadDone: function (results, paramList) {
        $("#js-faq-modal-area").html(results["template"]);
        modalWindow.showModal("#js-modal-edit");

        // ボタンの有効化
        modalWindow.enableButton();
        faq.enableButtons();

        // 保存ボタンを押したとき
        $(".js-upload-button").unbind();
        $(".js-update-button").click(function () {
            form.disableButtons(this);

            const url = $("#faqForm").attr("action");
            form.post(url, "#faqForm", "よくある質問の更新が完了しました", function (results) {
                faq.uploadDone(results);
                modalWindow.hideModal("#js-modal-edit");
            });
        });
    },

    // 更新が完了
    uploadDone: function (results, paramList) {
        const faqId = results["faqId"];

        if ($('[data-faq_id="' + faqId + '"]').length != 0) {
            $('[data-faq_id="' + faqId + '"]').html(results["template"]);
        } else {
            // 枠を一番下に追加
            $(".nursery-faq__list-container--add").before(results["template"]);
        }

        pageFaq.getItem(faqId);
    },
    // 削除が完了した
    deleteDone: function (results, paramList) {
        $('[data-faq_id="' + paramList.get("id") + '"]').remove();
    }
};
